module.exports = __webpack_public_path__ + "img/img_ticket_top.f688bb39.jpg";